import { v4 as uuid } from 'uuid';
import { Error, ServerError } from '../ErrorHandling';
import { TPlainTextKey } from '../Translations';

export interface WarningAlert {
  kind: 'warning-alert';
  uuid: string;
  message: TPlainTextKey;
}

export interface SuccessAlert {
  kind: 'success-alert';
  uuid: string;
  message: TPlainTextKey;
}

export const successAlert = (message: TPlainTextKey): SuccessAlert => ({
  kind: 'success-alert',
  uuid: uuid(),
  message,
});

export interface InfoAlert {
  kind: 'info-alert';
  uuid: string;
  message: TPlainTextKey;
}

export interface ErrorAlert {
  kind: 'error-alert';
  uuid: string;
  error: Error;
}

export interface ServerErrorAlert {
  kind: 'server-error-alert';
  uuid: string;
  serverError: ServerError;
}

export const errorAlert = (error: Error): ErrorAlert => ({
  kind: 'error-alert',
  error,
  uuid: uuid(),
});

export const serverErrorAlert = (serverError: ServerError): ServerErrorAlert => ({
  kind: 'server-error-alert',
  serverError,
  uuid: uuid(),
});

export type FlashAlert = WarningAlert | SuccessAlert | InfoAlert | ErrorAlert | ServerErrorAlert;
